import { render, staticRenderFns } from "./VentaReal.vue?vue&type=template&id=984b4062"
import script from "./VentaReal.vue?vue&type=script&lang=js"
export * from "./VentaReal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports